module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='" + (['inline-comment-button-wrapper', "" + ($e($c((!this.enabled ? 'disabled' : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "' style='top: " + ($e($c(this.top))) + "px;'>\n  <button class='inline-comment-button' disabled='" + ($e($c(!this.enabled))) + "' type='button'>\n    <div class='button small'>\n      <span class='icon icon-plus'></span>\n      <span class='icon icon-comment'></span>\n    </div>\n  </button>");
      if (!(this.enabled || !this.fetched)) {
        $o.push("  <span class='icon icon-question-circle modal-open' data-modal='comment-not-allowed'></span>");
      }
      $o.push("</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/comments/inline_comment_button.js.hamlc
// module id = 1570
// module chunks = 18